<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 14 14"
  >
    <g>
      <g>
        <ellipse id="selected-box" cx="7" cy="7" rx="7" ry="7" fill="#FFFFFF" fill-opacity="1" />
      </g>
      <g>
        <path
         id="selected"
          d="M10.732049904632568,5.7163361907348635Q10.812859904632568,5.632474190734864,10.856429904632568,5.524468190734863Q10.899999904632569,5.416463190734864,10.899999904632569,5.300000190734863Q10.899999904632569,5.240905390734863,10.888469904632569,5.182946190734863Q10.876939904632568,5.124986190734863,10.854329904632568,5.070390190734863Q10.831709904632568,5.015793190734863,10.798879904632567,4.966658190734863Q10.766049904632569,4.917522190734863,10.724259904632568,4.875736190734863Q10.682479904632569,4.833950190734863,10.633339904632567,4.801118190734863Q10.58420990463257,4.768287190734863,10.529609904632569,4.745672190734863Q10.475009904632568,4.723058190734863,10.417049904632568,4.711529190734863Q10.359089904632569,4.700000190734864,10.299999904632568,4.700000190734864Q10.177759904632568,4.700000190734864,10.065269904632569,4.747822190734864Q9.952769904632568,4.795644190734864,9.867949904632567,4.883664190734863L6.779169904632568,8.089000190734863Q6.634809904632569,8.238820190734863,6.4267599046325685,8.240240190734863Q6.2187099046325685,8.241670190734864,6.072309904632569,8.093860190734864L4.526288904632568,6.532970190734863Q4.441776904632569,6.447650190734864,4.330935904632568,6.401430190734863Q4.220093904632568,6.355200190734863,4.099999904632568,6.355200190734863Q4.040905104632568,6.355200190734863,3.9829459046325684,6.366730190734863Q3.9249859046325684,6.3782601907348635,3.8703899046325683,6.400880190734863Q3.8157929046325685,6.423490190734864,3.7666579046325683,6.456320190734863Q3.7175219046325685,6.489150190734863,3.6757359046325684,6.530940190734864Q3.6339499046325683,6.572730190734863,3.6011179046325683,6.621860190734863Q3.5682869046325685,6.671000190734864,3.5456719046325684,6.725590190734863Q3.5230579046325685,6.780190190734864,3.511528904632568,6.838150190734863Q3.4999999046325683,6.896110190734863,3.4999999046325683,6.955200190734863Q3.4999999046325683,7.073810190734863,3.5451249046325684,7.183490190734863Q3.5902489046325683,7.293170190734863,3.673710904632568,7.377430190734863L3.6738539046325682,7.3775801907348635L5.219729904632568,8.938320190734864Q5.721699904632568,9.445110190734862,6.434999904632568,9.440220190734863Q7.148299904632568,9.435320190734863,7.643259904632568,8.921680190734863L10.73172990463257,5.716665190734863L10.732049904632568,5.7163361907348635L10.732049904632568,5.7163361907348635Z"
          fill-rule="evenodd"
          fill="#fff"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
  <script>
export default {
  name: "SelectedSvg",
  props: {
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$el.querySelector("#selected-box").setAttribute("fill", this.color);
    },
  },
};
</script>
<style scoped lang="less">
svg {
  .adapt_pc_widescreen & {
    width: 20px;
    height: 20px;
  }
}
</style>
  